import { TooltipCollection } from './global/tooltip.js';
import { LoaderCollection } from './global/loader.js';
import { MobileMenu } from './elements/mobile-menu.js';
import { initFormValidation, initFilledInputs } from './elements/forms.js';
import { RollupTextButtonAnimation } from './global/button-animations.js';
import { DevTools } from './global/dev-tools.js';
import * as utils from './global/utilities.js';
import CF7UTMTracking from './global/cf7-utm-tracking.js';

// Initialize form validation for Contact Form 7
initFormValidation();
// Initialize filled state listeners for form fields
initFilledInputs();

document.addEventListener('DOMContentLoaded', () => {
    window.CF7UTMTracking = new CF7UTMTracking([".wpcf7-form"]);
});

// Initialize the LoaderCollection when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
    window.LoaderCollection = new LoaderCollection([".wpcf7-form", ".syn-post-grid"]);
});

document.addEventListener('DOMContentLoaded', () => {
    const tooltips = document.querySelectorAll('[data-tooltip]');
    const tooltipCollection = new TooltipCollection(tooltips);
});

// Mobile Menu
document.addEventListener('DOMContentLoaded', () => {
    const mobileMenu = new MobileMenu('#navbar-mobile', '.navbar-toggler');
});

// Desktop Menu Mega Menu Fixes
document.addEventListener('DOMContentLoaded', () => {
    const desktopMenuItems = document.querySelectorAll('.site-header .main-menu > li');
    const childrenMenuItems = document.querySelectorAll('.site-header .main-menu > li > .sub-menu > li');

    // Initial state so the first one is display on open of the menu
    desktopMenuItems.forEach(item => {
        let closeTimeout;

        item.addEventListener('mouseleave', () => {
            closeTimeout = setTimeout(() => {
                item.classList.remove('is-active');

                const child = item.querySelector('li.menu-item-level-1');

                if (child) {
                    child.classList.remove('is-active');
                }
            }, 125);
        });

        item.addEventListener('mouseenter', () => {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
            }

            item.classList.add('is-active');

            const child = item.querySelector('li.menu-item-level-1');

            if (child) {
                child.classList.add('is-active');
            }
        });
    });

    childrenMenuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
            const siblings = item.parentElement.querySelectorAll('li');

            siblings.forEach(sibling => {
                sibling.classList.remove('is-active');
            });
        });
    });
});

// Toggle transparent class on body based on scroll position
// Transparent class is set individually on each page via ACF - Page Options -> Header Style.
document.addEventListener('DOMContentLoaded', () => {
    const body = document.body;

    window.synapse = window.synapse || {};
    window.synapse.headerStyle = body.classList.contains('header-style--transparent') ? 'transparent' : 'default';

    const toggleTransparentClass = () => {
        if (window.scrollY > 50 && window.synapse.headerStyle === 'transparent') {
            body.classList.remove('header-style--transparent');
        } else {
            if (window.synapse.headerStyle === 'transparent') {
                body.classList.add('header-style--transparent');
            }
        }
    };

    window.addEventListener('scroll', utils.debounce(toggleTransparentClass, 10));
});

// Header desktop search toggle
document.addEventListener('DOMContentLoaded', () => {
    const searchToggle = document.querySelector('button#toggleSearchForm');
    const searchFormWrapper = document.querySelector('.desktop-search-form-contain');

    if (searchToggle && searchFormWrapper) {
        searchToggle.addEventListener('click', () => {
            searchFormWrapper.classList.toggle('is-active');
            if (searchFormWrapper.classList.contains('is-active')) {
                searchToggle.setAttribute('aria-expanded', 'true');
                searchToggle.setAttribute('aria-label', 'Close search form');
            } else {
                searchToggle.setAttribute('aria-expanded', 'false');
                searchToggle.setAttribute('aria-label', 'Open search form');
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const synapse = window.synapse || {};

    // synapse.devTools = new DevTools();

    window.synapse = synapse;
});

// Masked email links
document.addEventListener('DOMContentLoaded', () => {
    $('.masked-mailto').on('mouseenter click', function () {
        var $this = $(this);
        var address = $this.data('address');
        var decoded_address = atob(address);
        $this.attr('href', 'mailto:' + decoded_address);
        $this.attr('data-address', '');
        $this.removeClass('masked-mailto');
    });
});

// CTA button animations
document.addEventListener('DOMContentLoaded', () => {
    const rollupTextButtonElements = [
        'main .cta.cta--inline',
        'main a.card--resource .button',
        'header li.cta-style--inline a',
    ];

    rollupTextButtonElements.forEach(selector => {
        const buttons = document.querySelectorAll(selector);

        buttons.forEach(button => {
            new RollupTextButtonAnimation(button, {
                textSelector: '.text'
            });
        });
    });
});

// on hover of every a link, add the rel="prerender" attribute
document.addEventListener('DOMContentLoaded', () => {
    const links = document.querySelectorAll('a');

    links.forEach(link => {
        link.addEventListener('mouseenter', () => {
            if (!link.hasAttribute('rel')) {
                link.setAttribute('rel', 'prerender');
            } else if (!link.getAttribute('rel').includes('prerender')) {
                link.setAttribute('rel', link.getAttribute('rel') + ' prerender');
            }
        });
    });
});

// add smooth scrolling to all anchor links
document.addEventListener('DOMContentLoaded', () => {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const targetId = link.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            const header = document.querySelector('.site-header');
            const headerHeight = header ? header.offsetHeight : 0;

            if (targetElement) {
                e.preventDefault();

                let scrollToPosition = $(targetElement).offset().top - headerHeight - 20;

                if (scrollToPosition <= 150) {
                    scrollToPosition = 0;
                }

                $('html, body').animate({
                    scrollTop: scrollToPosition
                }, 500).promise().done(() => {
                    if (targetElement.classList.contains('form-anchor')) {
                        $(targetElement.parentElement).addClass('animate-glow').focus();
                    } else {
                        $(targetElement).addClass('animate-glow').focus();
                    }
                });
            }
        });
    });
});

function handleDynamicFormCampaignField(selector) {
    const elements = document.querySelectorAll(selector);
    const formCampaignOverrride = document.body.dataset.formCampaign;

    if (elements) {
        elements.forEach(element => {
            let formCampaign = element.dataset.formCampaign;

            // override always wins if it's set on the body, this is for ease of use in case the client wants to set the campaign for the entire page without having to set it on each individual hero element
            if (formCampaignOverrride) {
                formCampaign = formCampaignOverrride;
            }
            
            if (formCampaign) {
                const form = element.querySelector('form');
                const campaignField = form ? form.querySelector('input[name="campaign"]') : null;

                if (campaignField) {
                    campaignField.value = formCampaign;
                }
            }
        });
    }
}

// Helper script to fill out hidden campaign field in forms for better tracking in analytics. For ease of use, the client can enter this on the component level.
document.addEventListener('DOMContentLoaded', () => {
    handleDynamicFormCampaignField('.syn-hero-container .slide');
    handleDynamicFormCampaignField('.column.form-column');
});

// Change the state / province based on the country selection in the contact form
document.addEventListener('DOMContentLoaded', () => {
    const countrySelect = document.querySelector('select[name="country"]');
    const stateSelect = document.querySelector('select[name="state"]');

    if (countrySelect && stateSelect) {
        // clear the state select options on page load
        stateSelect.innerHTML = '<option value="">Select one...</option>';
        
        countrySelect.addEventListener('change', () => {
            const selectedCountry = countrySelect.value;

            // Clear existing options
            stateSelect.innerHTML = '<option value="">Select one...</option>';

            if (selectedCountry === 'United States') {
                const usStates = ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"];
                
                usStates.forEach(state => {
                    const option = document.createElement('option');

                    // NOTE: This is here because this is the value that currently exists in their HubSpot State property. It's a believed mistake from the HS admin team.
                    if (state === "Pennsylvania") {
                        option.value = "PennsylvaniaRhode Island";
                    } else {
                        option.value = state;
                    }
                    
                    option.textContent = state;
                    stateSelect.appendChild(option);
                });
            } else if (selectedCountry === 'Canada') {
                const canadianProvinces = ["Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Nova Scotia", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan"];
                
                canadianProvinces.forEach(province => {
                    const option = document.createElement('option');
                    option.value = province;
                    option.textContent = province;
                    stateSelect.appendChild(option);
                });
            } else {
                stateSelect.innerHTML = '<option value="">Select one...</option>';
            }
        });
    }
});